import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fvk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402 && window.location.pathname !== "/signin") window.location.assign("/signin");
    if (err?.response?.status === 403 && /read-only/.test(err.response.data?.detail || "")) toast.error(err.response.data.detail);
    return Promise.reject(err);
  }
);


export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || "").join(" ");
  return e?.message || "Something went wrong. Please try again.";
}

export const saveRelationship = async (id, relationship) => {
  const { data } = await api.patch(`/members/${id}/relationship`, { relationship });
  if (data.changed) toast.success(`Relationship updated to ${data.member.relationship}.`);
  if (data.audio_notice) toast.warning(data.audio_notice, { duration: 15000, style: { background: "#1A1222", color: "#EDE6F7", border: "1px solid #8B2CFF" } });
  return data;
};

export { API };
